import { techStack } from "./architecture";

export function AboutStack() {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 12 }}>
      {techStack.map((t) => (
        <article key={t.id} className="card lex-stack-card" style={{ padding: 22 }}>
          <div className="lex-eyebrow">{t.category.toUpperCase()}</div>
          <h3 style={{ font: "var(--t-headline-sm)", fontStyle: "italic", margin: "4px 0 12px 0", color: "var(--md-primary)" }}>
            {t.choice}
          </h3>
          <p style={{ font: "var(--t-body-md)", color: "var(--md-on-surface-var)", margin: 0 }}>
            {t.rationale}
          </p>
          {t.alternatives.length > 0 && (
            <div style={{ marginTop: 14 }}>
              <div style={{ font: "var(--t-label-sm)", color: "var(--md-on-surface-var)", marginBottom: 6 }}>
                Considered alternatives
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {t.alternatives.map((a) => (
                  <span key={a} className="lex-chip lex-chip--outlined" data-size="sm">{a}</span>
                ))}
              </div>
            </div>
          )}
        </article>
      ))}
    </div>
  );
}

export default AboutStack;
